import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { LinkToTestManagementToolsDoc } from '../links'

const IntegrationZephyrExecutedByID = () =>
  <div className='grid gap-4'>
    <div className='grid gap-3'>
      <Header
        hasNoTopMargin
        lessWeight
        rank={3}
      >
        Executed by ID
      </Header>
      <Paragraph>
        <strong>
          <Color variant='theme-description-text'>
            The Jira user ID of the person or automation that executed this test. This ID is generated and managed by Jira. To view or update who executes the test, manage execution or automation settings in Jira.
          </Color>
        </strong>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToTestManagementToolsDoc />
    </Paragraph>
  </div>

export default IntegrationZephyrExecutedByID
